import React from 'react';
import { Loader2 } from 'lucide-react';

interface LoadingProps {
  text?: string;
  size?: 'sm' | 'md' | 'lg';
}

const sizeClasses = {
  sm: 'w-4 h-4',
  md: 'w-8 h-8',
  lg: 'w-12 h-12',
};

// PERFORMANCE: Memoized to prevent re-renders when props don't change
export const Loading = React.memo<LoadingProps>(({ text = 'Loading...', size = 'md' }) => {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <Loader2 className={`${sizeClasses[size]} animate-spin text-rose-600 mb-3`} />
      <p className="text-neutral-600">{text}</p>
    </div>
  );
});

export const LoadingSpinner = React.memo<{ size?: 'sm' | 'md' | 'lg' }>(({ size = 'md' }) => {
  return <Loader2 className={`${sizeClasses[size]} animate-spin text-rose-600`} />;
});
